import TurboModalTogglerController from 'controllers/common/turbo_modal_toggler_controller';

export default class extends TurboModalTogglerController {
  connect() {}

  closeIfFetchResponseOk(event) {
    if (event.detail.fetchResponse.response.ok) {
      this.close({ params: event.params });
    }
  }
}
